'use strict';

var log = require('../../log/Log').channel('DisplayController');
var defaults = require('../../defaults/Defaults');
var formatMeetingId = require('./FormatMeetingId');
var objToArray = require('./ObjectToArray');
var sutl = require('../../sutl/Sutl');
var TooltipExtension = require('./TooltipExtension').default;
var VolumeControlsExtension = require('./VolumeControlsExtension').VolumeControlsExtension;
require('./DisplaySourceStateService');
require('./ImageDownloadService');
require('./SelectMenuPositionService');

angular
    .module('inara')
    .directive('displayControl', function () {
        // Directive defining toggle/buttons for display power, blank, freeze
        return {
            restrict: 'E',
            templateUrl: 'displayControl.html',
            scope: {
                controlLabel: '<',
                controlGetterSetter: '<',
                controlOffIconClass: '<',
                controlOnIconClass: '<',
                controlToggleIconClass: '<',
                hasControl: '<',
                hasControlUi: '<',
                isControlStateless: '<',
                isControlToggle: '<',
                isControlDisabled: '<',
            },
        };
    })

    .directive('displayMotionControl', function () {
        // Directive defining buttons for display motion controls
        return {
            restrict: 'E',
            templateUrl: 'displayMotionControl.html',
            scope: {
                controls: '<',
                controlLabel: '<',
                getControlIcon: '<',
                onControlRelease: '<',
                onControlTouch: '<',
                isControlDisabled: '<',
                preserveEmptyControls: '<',
            },
        };
    })

    .directive('mediaControlButtonWithPriority', function () {
        // Directive defining media control button with specified priority
        return {
            restrict: 'E',
            templateUrl: 'mediaControlButtonWithPriority.html',
            scope: {
                hasMediaOperation: '<',
                isControlDisabled: '<',
                onMediaControlButtonClicked: '<',
                selectedSource: '<',
                getMediaControlButtonWithPriority: '<',
                priority: '<',
            },
        };
    })

    .directive('mediaControlsDirection', function () {
        // Directive defining media controls direction/navigation column
        return {
            restrict: 'E',
            templateUrl: 'mediaControlsDirection.html',
            scope: {
                hasMediaOperation: '<',
                isControlDisabled: '<',
                onMediaControlButtonClicked: '<',
                selectedSource: '<',
                getMediaControlButtonWithPriority: '<',
            },
        };
    })

    .directive('mediaControlsColumn', function () {
        // Directive defining an array of media controls
        return {
            restrict: 'E',
            templateUrl: 'mediaControlsColumn.html',
            scope: {
                controls: '<',
                columnClasses: '@',
                hasMediaOperation: '<',
                anyControlHasMediaOperation: '<',
                getMediaControlButtonClasses: '<',
                isControlDisabled: '<',
                onMediaControlButtonClicked: '<',
                getSource: '<',
                displayId: '<',
                sourceId: '<',
            },
        };
    })

    .directive('sourceStates', function () {
        // Directive defining an array of source status items
        return {
            restrict: 'E',
            templateUrl: 'sourceStates.html',
            scope: {
                sourceStates: '<',
                maxNumStates: '<',
                formatSourceState: '<',
                getActiveSourceStatesCount: '<',
                getSourceState: '<',
                getSourceStateIcon: '<',
                selectedDisplayId: '<',
                selectedSourceId: '<',
                showSourceStateStopButton: '<',
                onStopSourceState: '<',
                onShowMoreSourceStates: '<',
            },
        };
    })

    .directive('channelControls', function () {
        // Directive defining media controls right column
        return {
            restrict: 'E',
            templateUrl: 'channelControls.html',
            scope: {
                hasMediaOperation: '<',
                isControlDisabled: '<',
                onMediaControlButtonClicked: '<',
                onShowChannelSelectionMenu: '<',
                selectedSource: '<',
                showTitle: '<',
            },
        };
    })

    .controller('DisplayController', DisplayController);

DisplayController.$inject = [
    '$scope',
    'RoomService',
    'SelectMenuPositionService',
    'ionicMaterialInk',
    '$timeout',
    '$ionicPopover',
    '$ionicScrollDelegate',
    '$ionicPosition',
    '$document',
    '$q',
    '$location',
    'gettextCatalog',
    '$state',
    'KayleeService',
    'ImageDownloadService',
    '$filter',
    'aveoTabsDelegate',
    'DisplaySourceStateService',
    'IosTouchEventService',
    '$window',
];

function DisplayController(
    $scope,
    RoomService,
    SelectMenuPositionService,
    ionicMaterialInk,
    $timeout,
    $ionicPopover,
    $ionicScrollDelegate,
    $ionicPosition,
    $document,
    $q,
    $location,
    gettextCatalog,
    $state,
    KayleeService,
    ImageDownloadService,
    $filter,
    aveoTabsDelegate,
    DisplaySourceStateService,
    IosTouchEventService,
    $window
) {
    var vm = this;
    var channelFavoriteImages = ImageDownloadService.getImageCache('channelFavorites');
    var channelSelectionMenu = null;
    var channelSelectionMenuPromise = null;
    var displayControlMenu = null;
    var displayControlMenuPromise = null;
    var displayControls = {};
    var displaySourceMenu = null;
    var displaySourceMenuPromise = null;
    var mediaControlsRightTemplate = [
        {
            capsMediaOperation: 'pageUpDown',
            mediaOperation: 'pageUp',
            icon: 'ion-android-arrow-dropup',
            getLabel: function (source) {
                /// Label for TV tuner page up/down buttons
                return gettextCatalog.getString('Page');
            },
        },
        {
            capsMediaOperation: 'pageUpDown',
            mediaOperation: 'pageDown',
            icon: 'ion-android-arrow-dropdown',
        },
    ];
    var mediaTabs = [
        {
            name: 'channel',
            getLabel: function (mediaOperations) {
                /// Label for TV tuner channel functions tab
                return gettextCatalog.getString('Channel');
            },
            mediaOperations: ['channelUpDown', 'channelPrevious', 'keyDigits'],
        },
        {
            name: 'player',
            getLabel: function (source) {
                if (
                    hasMediaOperation(source, /^mediaPlayer(?!Record)/) &&
                    hasMediaOperation(source, /^mediaPlayerRecord/)
                ) {
                    /// Label for media play/record functions tab
                    return gettextCatalog.getString('Play/Record');
                }
                /// Label for media play functions tab
                return gettextCatalog.getString('Play');
            },
            mediaOperations: /^mediaPlayer/,
            controls: [
                [
                    {
                        mediaOperation: 'mediaPlayerPlay',
                        icon: 'ion-play',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'playing',
                            class: 'highlight',
                        },
                    },
                    {
                        mediaOperation: 'mediaPlayerPlayToggle',
                        icon: 'ion-play',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'playing',
                            class: 'highlight',
                        },
                    },
                    {
                        mediaOperation: 'mediaPlayerPause',
                        icon: 'ion-pause',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'paused',
                            class: 'highlight',
                        },
                    },
                    {
                        mediaOperation: 'mediaPlayerRecord',
                        icon: 'ion-record',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'recording',
                            class: 'alert',
                        },
                    },
                    {
                        mediaOperation: 'mediaPlayerRecordToggle',
                        icon: 'ion-record',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'recording',
                            class: 'alert',
                        },
                    },
                    { mediaOperation: 'mediaPlayerStop', icon: 'ion-stop' },
                ],
                [
                    {
                        mediaOperation: 'mediaPlayerReverse',
                        icon: 'ion-ios-rewind',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'reversing',
                            class: 'highlight',
                        },
                    },
                    {
                        mediaOperation: 'mediaPlayerForward',
                        icon: 'ion-ios-fastforward',
                        state: {
                            name: 'mediaPlayerState',
                            value: 'forwarding',
                            class: 'highlight',
                        },
                    },
                ],
                [
                    { mediaOperation: 'mediaPlayerSkipBack', icon: 'ion-ios-undo' },
                    { mediaOperation: 'mediaPlayerSkipAhead', icon: 'ion-ios-redo' },
                ],
                [
                    { mediaOperation: 'mediaPlayerPrevious', icon: 'ion-ios-skipbackward' },
                    { mediaOperation: 'mediaPlayerNext', icon: 'ion-ios-skipforward' },
                ],
            ],
            states: ['mediaPlayerState'],
        },
        {
            name: 'recorder',
            getLabel: function (source) {
                /// Label for media record functions tab
                return gettextCatalog.getString('Record');
            },
            mediaOperations: /^mediaRecorder/,
            controls: [
                [
                    {
                        mediaOperation: 'mediaRecorderRecord',
                        icon: 'ion-record',
                        state: {
                            name: 'mediaRecorderState',
                            value: 'recording',
                            class: 'alert',
                        },
                    },
                    {
                        mediaOperation: 'mediaRecorderRecordToggle',
                        icon: 'ion-record',
                        iconClass: 'alert',
                        state: {
                            name: 'mediaRecorderState',
                            value: 'recording',
                            class: 'alert',
                        },
                    },
                    {
                        mediaOperation: 'mediaRecorderPause',
                        icon: 'ion-pause',
                        state: {
                            name: 'mediaRecorderState',
                            value: 'paused',
                            class: 'highlight',
                        },
                    },
                    { mediaOperation: 'mediaRecorderStop', icon: 'ion-stop' },
                ],
            ],
            states: ['mediaRecorderState'],
        },
        {
            name: 'streamer',
            getLabel: function (source) {
                /// Label for media streaming functions tab
                return gettextCatalog.getString('Stream');
            },
            mediaOperations: /^mediaStreamer/,
            controls: [
                [
                    {
                        mediaOperation: 'mediaStreamerStream',
                        icon: 'ion-aveo-broadcast',
                        iconClass: 'highlight',
                        state: {
                            name: 'mediaStreamerState',
                            value: 'streaming',
                            class: 'highlight',
                        },
                    },
                    { mediaOperation: 'mediaStreamerStop', icon: 'ion-aveo-broadcast-off' },
                ],
            ],
            states: ['mediaStreamerState'],
        },
    ];
    var noDisplaySelectedIcon = '';
    var previousChannelFavorites = null;
    var previousConfiguredDisplays = null;
    var previousDisplays = null;
    var previousDisplaysState = null;
    var previousSelectedDisplayId = null;
    var prioritizedMediaControls = [
        {
            mediaOperation: 'menu',
            icon: 'ion-android-menu',
            getLabel: function (source) {
                /// Label for TV tuner menu button
                return gettextCatalog.getString('Menu');
            },
        },
        {
            mediaOperation: 'exit',
            icon: 'ion-android-close',
            getLabel: function (source) {
                /// Label for TV tuner exit button
                return gettextCatalog.getString('Exit');
            },
        },
        {
            mediaOperation: 'home',
            icon: 'ion-android-home',
            getLabel: function (source) {
                /// Label for TV tuner home button
                return gettextCatalog.getString('Home');
            },
        },
        {
            mediaOperation: 'back',
            icon: 'ion-android-arrow-u-left-top',
            getLabel: function (source) {
                /// Label for TV tuner back button
                return gettextCatalog.getString('Back');
            },
        },
        {
            mediaOperation: 'guide',
            icon: 'ion-aveo-channel-guide',
            getLabel: function (source) {
                /// Label for TV tuner guide button
                return gettextCatalog.getString('Guide');
            },
        },
        {
            mediaOperation: 'info',
            icon: 'ion-android-information-outline',
            getLabel: function (source) {
                /// Label for TV tuner information button
                return gettextCatalog.getString('Info');
            },
        },
    ];
    var room = null;
    var sourceIcons = {
        camera: 'ion-aveo-camera-started',
        desktop_computer: 'ion-aveo-desktop-computer',
        disk: 'ion-aveo-disk',
        laptop: 'ion-aveo-laptop',
        layout_fullscreen: 'ion-aveo-view-fullscreen',
        layout_pip_bottom_left: 'ion-aveo-view-pip-bottom-left',
        layout_pip_bottom_right: 'ion-aveo-view-pip-bottom-right',
        layout_pip_top_left: 'ion-aveo-view-pip-top-left',
        layout_pip_top_right: 'ion-aveo-view-pip-top-right',
        layout_reduced_center: 'ion-aveo-view-reduced-center',
        layout_split_horizontal: 'ion-aveo-view-split-horizontal',
        layout_split_vertical: 'ion-aveo-view-split-vertical',
        layout_three_by_three: 'ion-aveo-view-gallery',
        layout_two_by_two: 'ion-aveo-view-two-by-two',
        tv: 'ion-aveo-monitor',
        usb: 'ion-aveo-usb',
        video_conference: 'ion-aveo-video-conference',
        wireless: 'ion-aveo-wireless-network',
    };
    var sourceInstructions = {};
    var sourceStateMenu = null;
    var sourceStateMenuPromise = null;

    log.info('initializing');

    angular.extend(vm, new TooltipExtension($scope, $ionicPopover));

    vm.anyControlHasMediaOperation = anyControlHasMediaOperation;
    vm.anyControlRowHasMediaOperation = anyControlRowHasMediaOperation;
    vm.anyDisplayControlsWithExtraColumn = anyDisplayControlsWithExtraColumn;
    vm.anyDisplayHasMediaControls = anyDisplayHasMediaControls;
    vm.anySwitcherHasPowerControl = anySwitcherHasPowerControl;
    vm.channelFavorites = null;
    vm.displayCardNeedsMaxHeight = displayCardNeedsMaxHeight;
    vm.formatDisplayVolume = formatDisplayVolume;
    vm.formatSourceState = formatSourceState;
    vm.getActiveSourceStatesCount = DisplaySourceStateService.getActiveSourceStatesCount;
    vm.getChannelFavoriteLabel = getChannelFavoriteLabel;
    vm.getChannelFavoriteStyle = getChannelFavoriteStyle;
    vm.getDefaultDisplayName = function () {
        /// Default name for display card when no custom display name entered
        return gettextCatalog.getString('Display');
    };
    vm.getDisplay = getDisplay;
    vm.getDisplayControlLimit = getDisplayControlLimit;
    vm.getDisplayControlSlots = getDisplayControlSlots;
    vm.getDisplayState = getDisplayState;
    vm.getDisplayControls = function (displayId) {
        if (!displayControls.hasOwnProperty(displayId)) return null;
        return displayControls[displayId];
    };
    vm.getEmptySelectionLabel = function () {
        /// Placeholder in selection box when nothing is selected yet
        return gettextCatalog.getString('Select...');
    };
    vm.getMediaActiveCount = getMediaActiveCount;
    vm.getSource = getSource;
    vm.getSelectedSource = getSelectedSource;
    vm.getSelectedSourceId = getSelectedSourceId;
    vm.getSourceIcon = getSourceIcon;
    vm.getMediaControlButtonClasses = getMediaControlButtonClasses;
    vm.getMediaControlButtonWithPriority = getMediaControlButtonWithPriority;
    vm.getMediaTabControls = getMediaTabControls;
    vm.getMediaTabStates = getMediaTabStates;
    vm.getSourceState = getSourceState;
    vm.getSourceStateIcon = getSourceStateIcon;
    vm.getSourceInstructions = getSourceInstructions;
    vm.getSwitcherTitle = getSwitcherTitle;
    vm.getUnavailableReason = getUnavailableReason;
    vm.getUnavailableReasonMsg = getUnavailableReasonMsg;
    vm.hasMediaOperation = hasMediaOperation;
    vm.hasSources = hasSources;
    vm.isEmptyString = function (str) {
        return !str || str.trim().length === 0;
    };
    vm.isMediaTabSupported = function (mediaTab) {
        return hasMediaOperation(getSelectedSource(vm.selectedDisplayId), mediaTab.mediaOperations);
    };
    vm.isSelectedSource = function (sourceState) {
        return sourceState.$id === getSelectedSourceId(vm.selectedDisplayId);
    };
    vm.isSourceIconSvg = isSourceIconSvg;
    vm.mediaControlsRight = [];
    vm.mediaTabs = mediaTabs;
    vm.onChannelFavoriteClicked = onChannelFavoriteClicked;
    vm.onKeypadClicked = onKeypadClicked;
    vm.onShowDisplayControlMenu = onShowDisplayControlMenu;
    vm.onStatelessHelpClicked = onStatelessHelpClicked;
    vm.onMediaControlButtonClicked = onMediaControlButtonClicked;
    vm.onMediaTabCountChanged = onMediaTabCountChanged;
    vm.onMediaTabSelected = onMediaTabSelected;
    vm.onSelectSource = onSelectSource;
    vm.onShowChannelSelectionMenu = onShowChannelSelectionMenu;
    vm.onShowDisplaySourceMenu = onShowDisplaySourceMenu;
    vm.onShowSourceStateMenu = onShowSourceStateMenu;
    vm.onStopSourceState = onStopSourceState;
    vm.onTabCountChanged = onTabCountChanged;
    vm.onTabSelected = onTabSelected;
    vm.showChannelInput = function () {
        return false;
    };
    vm.showMediaControls = showMediaControls;
    vm.showSourceStateStopButton = function (stateName) {
        return true;
    };
    vm.uiDisplayState = {};

    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    vm.volumeControls = new VolumeControlsExtension(
        $scope,
        $ionicPopover,
        $timeout,
        $window,
        $ionicPosition,
        IosTouchEventService,
        'displayVolumeControl.html',
        { ceil: 50, floor: 0 }
    );

    $scope.$on('$ionicView.afterEnter', function () {
        createDisplaySourceMenu();
        createChannelSelectionMenu();
        createSourceStateMenu();
        $timeout(function () {
            if (vm.selectedDisplayId) {
                aveoTabsDelegate
                    .$getByHandle('display-tabs')
                    .selectTabWithData(vm.selectedDisplayId);
                updateSelectedMediaTab();
            }
        }, 250);
    });

    $scope.$on('IdleTimeout', function () {
        hidePopovers();
    });

    $scope.$on('popover.hidden', function ($event, popover) {
        if (popover === displaySourceMenu) {
            delete $scope.display;
            delete $scope.displayId;
            $ionicScrollDelegate.$getByHandle('display-source-scroll').scrollTop(false);
        } else if (popover === channelSelectionMenu) {
            delete $scope.source;
        } else if (popover === displayControlMenu) {
            delete $scope.displayControlDisplayId;
        }
    });

    $scope.$on('popover.removed', function ($event, popover) {
        if (popover === displaySourceMenu) {
            displaySourceMenu = null;
            displaySourceMenuPromise = null;
        } else if (popover === channelSelectionMenu) {
            channelSelectionMenu = null;
            channelSelectionMenuPromise = null;
        } else if (popover === sourceStateMenu) {
            sourceStateMenu = null;
            sourceStateMenuPromise = null;
        } else if (popover === displayControlMenu) {
            displayControlMenu = null;
            displayControlMenuPromise = null;
        }
    });

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'control.display') hidePopovers();
    });

    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);
        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
        if (displaySourceMenuPromise !== null) {
            displaySourceMenuPromise.then(function (menu) {
                menu.remove();
            });
        }
        if (channelSelectionMenuPromise !== null) {
            channelSelectionMenuPromise.then(function (menu) {
                menu.remove();
            });
        }
        if (sourceStateMenuPromise !== null) {
            sourceStateMenuPromise.then(function (menu) {
                menu.remove();
            });
        }
        if (displayControlMenuPromise !== null) {
            displayControlMenuPromise.then(function (menu) {
                menu.remove();
            });
        }
        vm.tooltip.hide();
        vm.volumeControls.hideVolumeControls();
    });

    function anyControlHasMediaOperation(displayId, sourceId, controls) {
        if (!controls) return false;
        var source = getSource(displayId, sourceId);
        for (var i = 0; i < controls.length; i++) {
            if (
                (controls[i].capsMediaOperation &&
                    hasMediaOperation(source, controls[i].capsMediaOperation)) ||
                hasMediaOperation(source, controls[i].mediaOperation)
            ) {
                return true;
            }
        }
        return false;
    }

    function anyControlRowHasMediaOperation(displayId, sourceId, controlRows) {
        if (!controlRows) return false;
        for (var i = 0; i < controlRows.length; i++) {
            if (anyControlHasMediaOperation(displayId, sourceId, controlRows[i])) return true;
        }
        return false;
    }

    function anyDisplayControlsWithExtraColumn(displayId, startIndex, length) {
        var displayControls = vm.getDisplayControls(displayId);
        if (displayControls === null) return false;
        if (!angular.isDefined(startIndex)) startIndex = 0;
        startIndex = Math.min(Math.max(0, startIndex), displayControls.length - 1);
        if (!angular.isDefined(length)) length = displayControls.length;
        length = Math.min(Math.max(0, length), displayControls.length);
        for (var i = startIndex; i < length; i++) {
            if (
                displayControls[i].type === 'displayMotion' &&
                sutl.getNode(displayControls[i], 'controls.stop') !== null
            ) {
                return true;
            }
        }
        return false;
    }

    function anyDisplayHasMediaControls() {
        for (var displayId in vm.configuredDisplays) {
            if (!vm.configuredDisplays.hasOwnProperty(displayId)) continue;
            var display = vm.configuredDisplays[displayId];
            for (var sourceId in display.sources) {
                if (!display.sources.hasOwnProperty(sourceId)) continue;
                if (
                    getMediaOperations(displayId, sourceId) !== null ||
                    getSourceInstructions(displayId, sourceId) !== null
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    function anySourceHasState(display) {
        if (!hasSources(display)) return false;
        for (var sourceKey in display.sources) {
            if (!display.sources.hasOwnProperty(sourceKey)) continue;
            if (
                display.sources[sourceKey].farContent === true ||
                display.sources[sourceKey].isMediaPlayerStateless === false ||
                display.sources[sourceKey].isMediaRecorderStateless === false ||
                display.sources[sourceKey].isMediaStreamerStateless === false
            ) {
                return true;
            }
        }
        return false;
    }

    function anySwitcherHasPowerControl() {
        for (var key in vm.configuredDisplays) {
            if (vm.configuredDisplays.hasOwnProperty(key)) {
                if (vm.configuredDisplays[key].hasPowerControl === true) return true;
            }
        }
        return false;
    }

    function createBlankGetterSetter(id, initValue) {
        var blank = angular.isDefined(initValue) ? initValue : false;
        return function (blk, deviceUpdate) {
            if (arguments.length > 0) {
                blank = blk; // set local value immediately
                if (!deviceUpdate && room !== null) {
                    room.$requestDisplayBlank(id, blank);
                }
            }
            return blank;
        };
    }

    function createChannelSelectionMenu() {
        if (channelSelectionMenuPromise === null) {
            channelSelectionMenuPromise = $ionicPopover
                .fromTemplateUrl('channelSelectionMenu.html', {
                    scope: $scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: SelectMenuPositionService.createPositionViewHandler(),
                })
                .then(function (popover) {
                    channelSelectionMenu = popover;
                    return $q.resolve(channelSelectionMenu);
                });
        }
        return channelSelectionMenuPromise;
    }

    function createDisplayControlMenu() {
        if (displayControlMenuPromise === null) {
            displayControlMenuPromise = $ionicPopover
                .fromTemplateUrl('displayControlMenu.html', {
                    scope: $scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: SelectMenuPositionService.createPositionViewHandler(),
                })
                .then(function (popover) {
                    displayControlMenu = popover;
                    return $q.resolve(displayControlMenu);
                });
        }
        return displayControlMenuPromise;
    }

    function createDisplaySourceMenu() {
        if (displaySourceMenuPromise === null) {
            displaySourceMenuPromise = $ionicPopover
                .fromTemplateUrl('displaySourceMenu.html', {
                    scope: $scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: SelectMenuPositionService.createPositionViewHandler(
                        '#dummy-source-item',
                        $scope.display && $scope.display.sources
                            ? Object.keys($scope.display.sources).length
                            : 0
                    ),
                })
                .then(function (popover) {
                    displaySourceMenu = popover;
                    return $q.resolve(displaySourceMenu);
                });
        }
        return displaySourceMenuPromise;
    }

    function createDebouncedGetterSetter(id, initValue, debounceTime, valueQueryFn) {
        var value = initValue;
        var debounceTimeout = null;
        if (!angular.isDefined(id) || id === null) {
            log.error('createDebouncedGetterSetter: id must be provided');
            return null;
        }
        if (!angular.isFunction(valueQueryFn)) {
            log.error('createDebouncedGetterSetter: valueQueryFn must be a function');
            return null;
        }
        if (!angular.isDefined(debounceTime) || debounceTime === null) {
            debounceTime = 250;
        }
        return function (val, deviceUpdate, cancel) {
            if (arguments.length > 0) {
                if (cancel === true) {
                    if (debounceTimeout !== null) {
                        $timeout.cancel(debounceTimeout);
                        debounceTimeout = null;
                    }
                    return value;
                }
                if (!deviceUpdate) {
                    // set local value immediately
                    value = val;
                    if (angular.isDefined(debounceTime) && debounceTime > 0) {
                        if (debounceTimeout !== null) $timeout.cancel(debounceTimeout);
                        setTimeout();
                    }
                } else if (debounceTimeout === null) {
                    value = val;
                }
            }
            return value;
        };

        function setTimeout() {
            debounceTimeout = $timeout(function () {
                debounceTimeout = null;
                // query local value later
                value = valueQueryFn(id, setTimeout);
            }, debounceTime);
        }
    }

    function createFreezeGetterSetter(id, initValue) {
        var freeze = angular.isDefined(initValue) ? initValue : false;
        return function (frz, deviceUpdate) {
            if (arguments.length > 0) {
                freeze = frz; // set local value immediately
                if (!deviceUpdate && room !== null) {
                    room.$requestDisplayFreeze(id, freeze);
                }
            }
            return freeze;
        };
    }

    function createPowerGetterSetter(id, initValue) {
        var power = angular.isDefined(initValue) ? initValue : false;
        return function (pow, deviceUpdate) {
            if (arguments.length > 0) {
                power = pow; // set local value immediately
                if (!deviceUpdate && room !== null) {
                    // If user requested power on and there is a selected source,
                    // and the display is not power toggle or stateless power,
                    // select it again to turn the display on as well as any
                    // other equipment along the source path, otherwise, just
                    // request power.
                    if (pow && getSelectedSourceId(id)) {
                        if (sutl.getNode(getDisplay(id), 'isPowerToggle', false)) {
                            room.$requestPowerToggle(id);
                        } else if (sutl.getNode(getDisplay(id), 'isPowerStateless', false)) {
                            room.$requestPower(id, pow);
                        } else {
                            room.$requestDisplaySource(id, getSelectedSourceId(id));
                        }
                    } else if (sutl.getNode(getDisplay(id), 'isPowerToggle', false)) {
                        room.$requestPowerToggle(id);
                    } else {
                        room.$requestPower(id, pow);
                    }
                }
            }
            return power;
        };
    }

    function createSourceStateMenu() {
        if (sourceStateMenuPromise === null) {
            sourceStateMenuPromise = $ionicPopover
                .fromTemplateUrl('sourceStatesMenu.html', {
                    scope: $scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: SelectMenuPositionService.createPositionViewHandler(
                        '#dummy-source-item',
                        vm.selectedDisplaySourceStates ? vm.selectedDisplaySourceStates.length : 0
                    ),
                })
                .then(function (popover) {
                    sourceStateMenu = popover;
                    return $q.resolve(sourceStateMenu);
                });
        }
        return sourceStateMenuPromise;
    }

    function createVolumeGetterSetter(id, initValue) {
        var volume = angular.isDefined(initValue) ? initValue : 25;
        return function (vol, deviceUpdate) {
            if (arguments.length > 0) {
                volume = vol; // set local value immediately
                if (!deviceUpdate && room !== null) {
                    room.$requestDisplayVolume(id, volume);
                }
            }
            return volume;
        };
    }

    function createVolumeMuteGetterSetter(id, initValue) {
        var mute = angular.isDefined(initValue) ? initValue : false;
        return function (mu, deviceUpdate) {
            if (arguments.length > 0) {
                mute = mu; // set local value immediately
                if (!deviceUpdate && room !== null) {
                    room.$requestDisplayVolumeMuteToggle(id);
                }
            }
            return mute;
        };
    }

    function displayCardNeedsMaxHeight() {
        var displays = sutl.getNode(room, 'configuredCaps.displays');
        for (var displayId in displays) {
            if (!displays.hasOwnProperty(displayId)) continue;
            var display = vm.getDisplay(displayId);
            if (!display) continue;
            if (
                (display.hasPowerControl &&
                    display.hasBlank &&
                    display.hasBlankUi &&
                    display.hasFreeze &&
                    display.hasFreezeUi) ||
                anySourceHasState(display)
            )
                return true;
        }
        return false;
    }

    function formatDisplayVolume(displayId) {
        if (vm.getDisplay(vm.selectedDisplayId).isVolumeStateless) return '';
        var volume = vm.uiDisplayState[vm.selectedDisplayId].volume();
        if (!angular.isDefined(volume) || volume === null) return '0%';
        return (vm.uiDisplayState[vm.selectedDisplayId].volume() * 2).toString() + '%';
    }

    function formatSourceName(sourceName) {
        return '<span class="source-name">' + sourceName + '</span>';
    }

    function formatSourceState(displayId, sourceId, state) {
        var sourceName = sutl.getNode(room, [
            'configuredCaps',
            'displays',
            displayId,
            'sources',
            sourceId,
            'name',
        ]);
        var formatObj = { sourceName: formatSourceName(sourceName) };
        switch (state) {
            case 'connecting':
                /// Status message for content sharing on the display & sharing page
                return gettextCatalog.getString('Connecting {{sourceName}} ...', formatObj);

            case 'sending':
                /// Status message for content sharing on the display & sharing page
                return gettextCatalog.getString(
                    'Sharing {{sourceName}} with ' + 'remote participants',
                    formatObj
                );

            case 'recording':
                /// Status message for media recording on the display & sharing page
                return (
                    gettextCatalog.getString('Recording {{sourceName}}', formatObj) +
                    ' ' +
                    DisplaySourceStateService.getFormattedElapsedTime(
                        displayId,
                        sourceId,
                        'mediaRecorderStartTime'
                    )
                );

            case 'playing':
                /// Status message for media playing on the display & sharing page
                return gettextCatalog.getString('Playing {{sourceName}}', formatObj);

            case 'streaming':
                /// Status message for media streaming on the display & sharing page
                return gettextCatalog.getString('Streaming {{sourceName}}', formatObj);

            case 'paused':
                /// Status message for media paused on the display & sharing page
                return gettextCatalog.getString('Paused {{sourceName}}', formatObj);

            case 'forwarding':
                /// Status message for media fast forwarding on the display & sharing page
                return gettextCatalog.getString('Fast forwarding {{sourceName}}', formatObj);

            case 'reversing':
                /// Status message for media reversing (rewinding) on the display & sharing page
                return gettextCatalog.getString('Reversing {{sourceName}}', formatObj);

            default:
                /// Status message for unknown media state on the display & sharing page
                return gettextCatalog.getString(
                    '{{sourceName}} is in an unknown ' + 'state',
                    formatObj
                );
        }
    }

    function getAllMediaControlButtonsWithPriority(source, priority) {
        var foundCount = 0;
        var buttons = [];
        for (var i = 0; i < prioritizedMediaControls.length; i++) {
            if (hasMediaOperation(source, prioritizedMediaControls[i].mediaOperation)) {
                foundCount++;
                if (foundCount >= priority) buttons.push(prioritizedMediaControls[i]);
            }
        }
        return buttons;
    }

    function getBlankButtonLabel() {
        /// Button label to toggle display/projector blank function
        return gettextCatalog.getString('Blank');
    }

    function getChannelFavoriteLabel(favorite) {
        return favorite.name;
    }

    function getChannelFavoriteStyle(favorite) {
        var url = sutl.getNode(channelFavoriteImages, [favorite.$key, 'url']);
        if (url) {
            var style = sutl.getNode(channelFavoriteImages, [favorite.$key, 'style']);
            if (style !== null) return style;
            style = {
                'background-image': "url('" + url + "')",
            };
            sutl.setNode(channelFavoriteImages, [favorite.$key, 'style'], style);
            return style;
        }
        return null;
    }

    function getDisplay(displayId) {
        if (room === null || !RoomService.online()) return null;
        return sutl.getNode(room, ['configuredCaps', 'displays', displayId]);
    }

    function getDisplayControlLimit(displayId) {
        return (
            getDisplayControlSlots() -
            (displayControls[displayId].length > getDisplayControlSlots() ? 1 : 0)
        );
    }

    function getDisplayControlSlots() {
        return vm.tabCount > 1 ? 3 : 4;
    }

    function getDisplayState(displayId, path) {
        if (room === null || !RoomService.online()) return null;
        return sutl.getNode(room, ['states', 'displays', displayId, ...path]);
    }

    function getFreezeButtonLabel() {
        /// Button label to toggle display/projector freeze function
        return gettextCatalog.getString('Freeze');
    }

    function getMediaActiveCount(displayId, sourceId, mediaTab) {
        var count = 0;
        if (!angular.isArray(mediaTab.states)) return count;
        mediaTab.states.forEach(function (tabState) {
            count += DisplaySourceStateService.getActiveSourceStatesCount(
                displayId,
                sourceId,
                tabState
            );
        });
        return count;
    }

    function getMediaControlButtonClasses(displayId, sourceId, control) {
        var classes = control.icon ? control.icon : '';
        classes += control.iconClass ? (classes.length > 0 ? ' ' : '') + control.iconClass : '';
        var stateName = sutl.getNode(control, 'state.name');
        if (stateName !== null) {
            var stateValue = getSourceState(displayId, sourceId, stateName);
            var stateClass = sutl.getNode(control, 'state.class');
            if (stateValue === sutl.getNode(control, 'state.value') && stateClass !== null) {
                classes += (classes.length > 0 ? ' ' : '') + stateClass;
            }
        }
        return classes;
    }

    function getMediaControlButtonWithPriority(source, priority) {
        var foundCount = 0;
        for (var i = 0; i < prioritizedMediaControls.length; i++) {
            if (hasMediaOperation(source, prioritizedMediaControls[i].mediaOperation)) {
                foundCount++;
                if (foundCount >= priority) return prioritizedMediaControls[i];
            }
        }
        return null;
    }

    function getMediaOperations(displayId, sourceId) {
        if (
            !angular.isDefined(displayId) ||
            displayId === null ||
            !angular.isDefined(sourceId) ||
            sourceId === null
        ) {
            return null;
        }
        return sutl.getNode(vm.configuredDisplays, [
            displayId,
            'sources',
            sourceId,
            'mediaOperations',
        ]);
    }

    function getMediaTab(tabName) {
        var found;
        if (tabName) {
            found = vm.mediaTabs.find(function (el) {
                return el.name === tabName;
            });
        }
        return found;
    }

    function getMediaTabControls(tabName) {
        var found = getMediaTab(tabName);
        return found ? found.controls : found;
    }

    function getMediaTabStates(tabName) {
        var found = getMediaTab(tabName);
        return found ? found.states : found;
    }

    function getPowerButtonLabel() {
        /// Power button label
        return gettextCatalog.getString('Power');
    }

    function getSelectedSource(displayId) {
        if (
            room === null ||
            !RoomService.online() ||
            !displayId ||
            sutl.getNode(vm.uiDisplayState, [displayId, 'videoInput']) === null
        ) {
            return null;
        }
        var sourceId = vm.uiDisplayState[displayId].videoInput();
        return sutl.getNode(getDisplay(displayId), ['sources', sourceId]);
    }

    function getSelectedSourceId(displayId) {
        if (
            room === null ||
            !RoomService.online() ||
            !displayId ||
            sutl.getNode(vm.uiDisplayState, [displayId, 'videoInput']) === null
        ) {
            return null;
        }
        return vm.uiDisplayState[displayId].videoInput();
    }

    function getSource(displayId, sourceId) {
        return sutl.getNode(room, ['configuredCaps', 'displays', displayId, 'sources', sourceId]);
    }

    function getSourceIcon(source) {
        if (room === null || !RoomService.online() || !source || !angular.isDefined(source.icon)) {
            return noDisplaySelectedIcon;
        }
        if (!sourceIcons.hasOwnProperty(source.icon)) return sourceIcons.tv;
        return sourceIcons[source.icon];
    }

    function getSourceInstructions(displayId, sourceId) {
        if (
            !angular.isDefined(displayId) ||
            displayId === null ||
            !angular.isDefined(sourceId) ||
            sourceId === null
        ) {
            return null;
        }
        // Don't show instructions for the source if it is already sending.
        var path = ['states', 'displays', displayId, 'sources', sourceId, 'state'];
        if (sutl.getNode(room, path) === 'sending') return null;
        return sutl.getNode(sourceInstructions, [displayId, sourceId]);
    }

    function getSourceState(displayId, sourceId, stateProperty) {
        return sutl.getNode(room, [
            'states',
            'displays',
            displayId,
            'sources',
            sourceId,
            stateProperty,
        ]);
    }

    function getSourceStateIcon(sourceState) {
        var state = getSourceState(vm.selectedDisplayId, sourceState.$id, sourceState.$stateName);
        return sutl.getNode(sourceState, ['$state', 'iconStates', state]);
    }

    function getSwitcherTitle(displayId) {
        /// Label for display source switcher selection dropdown
        return gettextCatalog.getString('Select source:');
    }

    function getUnavailableReason(displayId, sourceId) {
        if (room === null || !RoomService.online()) return null;
        return sutl.getNode(room, [
            'caps',
            'displays',
            displayId,
            'sources',
            sourceId,
            'unavailableReason',
        ]);
    }

    function getUnavailableReasonMsg(displayId, sourceId) {
        switch (getUnavailableReason(displayId, sourceId)) {
            case 'notInZoomCall':
                /// Message for selecting camera as content sharing source outside Zoom meeting
                return gettextCatalog.getString('This source is only available in a Zoom meeting.');

            default:
                return null;
        }
    }

    function hasMediaOperation(source, operation) {
        if (angular.isString(operation)) operation = [operation];
        var mediaOperations = sutl.getNode(source, 'mediaOperations');
        if (mediaOperations !== null) {
            for (var key in mediaOperations) {
                if (!mediaOperations.hasOwnProperty(key)) continue;
                if (angular.isArray(operation) && operation.includes(mediaOperations[key])) {
                    return true;
                }
                if (
                    angular.isFunction(operation.exec) &&
                    operation.exec(mediaOperations[key]) !== null
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    function hasSources(display) {
        if (room === null || !RoomService.online()) return false;
        return angular.isDefined(display.sources);
    }

    function hidePopovers() {
        if (displaySourceMenuPromise !== null) {
            displaySourceMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
        if (channelSelectionMenuPromise !== null) {
            channelSelectionMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
        if (sourceStateMenuPromise !== null) {
            sourceStateMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
        if (displayControlMenuPromise !== null) {
            displayControlMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
        vm.tooltip.hide();
        vm.volumeControls.hideVolumeControls();
    }

    function isSourceIconSvg(source) {
        return (
            room !== null &&
            RoomService.online() &&
            source &&
            angular.isDefined(source.icon) &&
            typeof source.icon === 'object'
        );
    }

    function isSourceStateless(source, isStatelessProperty) {
        return sutl.getNode(source, [isStatelessProperty], false);
    }

    function onChannelFavoriteClicked(favorite) {
        var source = getSelectedSource(vm.selectedDisplayId);
        if (hasMediaOperation(source, 'channelSet')) {
            room.$requestMediaOperation(source.equipmentId, {
                operation: 'channelSet',
                channel: favorite.channel,
                videoInputId: source.videoInputId,
            });
        } else {
            log.warning('equipment ' + source.equipmentId + ' does not support channelSet');
        }
    }

    function onKeypadClicked(operation) {
        var source = getSelectedSource(vm.selectedDisplayId);
        if (operation === 'keyEnter') {
            // We always show the enter key on the keypad as an option for closing
            // the dialog. If it is also a supported media operation, we'll send
            // the request as well.
            if (hasMediaOperation(source, operation)) {
                room.$requestMediaOperation(source.equipmentId, {
                    operation: operation,
                    videoInputId: source.videoInputId,
                });
            }
            if (channelSelectionMenu && channelSelectionMenu.isShown()) {
                channelSelectionMenu.hide();
            }
        } else {
            room.$requestMediaOperation(source.equipmentId, {
                operation: operation,
                videoInputId: source.videoInputId,
            });
        }
    }

    function onMediaControlButtonClicked(source, operation, operationArg) {
        var req = {
            operation: operation,
            videoInputId: source.videoInputId,
        };
        if (operation === 'channelSet') req.channel = operationArg;
        if (operation === 'channelTunerSet') req.channelTuner = operationArg;
        if (angular.isDefined(operationArg)) req[operation] = operationArg;
        room.$requestMediaOperation(source.equipmentId, req);
    }

    function onMediaTabCountChanged(tabCount) {
        vm.mediaTabCount = tabCount;
    }

    function onMediaTabSelected(tab) {
        $timeout(function () {
            vm.selectedMediaTab = tab.tabData;
        });
    }

    function onRoomChanged() {
        if (room === null || !RoomService.online()) return;
        var id;
        var shouldUpdateDisplayControls = false;
        var videoInputWasSelected = false;
        if (
            previousConfiguredDisplays === null ||
            !sutl.objEquals(previousConfiguredDisplays, room.configuredCaps.displays)
        ) {
            previousConfiguredDisplays = sutl.deepCopy(room.configuredCaps.displays);
            vm.configuredDisplays = sutl.deepCopy(room.configuredCaps.displays);
            var prevDisplayId = vm.selectedDisplayId;
            var displayArray = objToArray(vm.configuredDisplays);
            vm.configuredDisplayTabs = displayArray
                .filter(function (display) {
                    return !sutl.getNode(display, 'isHidden', false);
                })
                .sort(function (display1, display2) {
                    var compared =
                        sutl.getNode(display1, 'index', displayArray.length - 1) -
                        sutl.getNode(display2, 'index', displayArray.length - 1);
                    return compared === 0 ? display1.$id.localeCompare(display2.$id) : compared;
                });
            if (
                vm.configuredDisplayTabs.length > 0 &&
                (!prevDisplayId ||
                    !vm.configuredDisplayTabs.find(function (el) {
                        return el.$id === prevDisplayId;
                    }))
            ) {
                prevDisplayId = vm.configuredDisplayTabs[0].$id;
            }
            $timeout(function () {
                if (prevDisplayId) {
                    aveoTabsDelegate.$getByHandle('display-tabs').selectTabWithData(prevDisplayId);
                    updateSelectedMediaTab();
                }
            }, 250);

            // cancel debounce timeouts for previous display state
            for (var key in vm.uiDisplayState) {
                if (!vm.uiDisplayState.hasOwnProperty(key)) continue;
                if (vm.uiDisplayState[key].videoInput) {
                    vm.uiDisplayState[key].videoInput(null, null, true);
                }
                if (vm.uiDisplayState[key].busy) {
                    vm.uiDisplayState[key].busy(null, null, true);
                }
            }
            vm.uiDisplayState = {};

            for (id in room.configuredCaps.displays) {
                if (!room.configuredCaps.displays.hasOwnProperty(id)) continue;
                vm.uiDisplayState[id] = {
                    videoInput: createDebouncedGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'videoInput']),
                        1500,
                        queryVideoInput
                    ),
                    busy: createDebouncedGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'busy'], false),
                        1000,
                        queryDisplayBusy
                    ),
                };
                if (sutl.getNode(room, ['states', 'displays', id, 'videoInput']) !== null) {
                    videoInputWasSelected = true;
                }
                vm.uiDisplayState[id].power = createPowerGetterSetter(
                    id,
                    sutl.getNode(room, ['states', 'displays', id, 'power'])
                );
                if (room.configuredCaps.displays[id].hasBlank) {
                    vm.uiDisplayState[id].blank = createBlankGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'blank'])
                    );
                }
                if (room.configuredCaps.displays[id].hasFreeze) {
                    vm.uiDisplayState[id].freeze = createFreezeGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'freeze'])
                    );
                }
                if (room.configuredCaps.displays[id].hasVolume) {
                    vm.uiDisplayState[id].volume = createVolumeGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'volume'])
                    );
                }
                if (room.configuredCaps.displays[id].hasVolumeMute) {
                    vm.uiDisplayState[id].volumeMute = createVolumeMuteGetterSetter(
                        id,
                        sutl.getNode(room, ['states', 'displays', id, 'volumeMute'])
                    );
                }
            }
            shouldUpdateDisplayControls = true;
        }

        if (previousDisplays === null || !sutl.objEquals(previousDisplays, room.caps.displays)) {
            previousDisplays = sutl.deepCopy(room.caps.displays);
            vm.displays = sutl.deepCopy(room.caps.displays);
            for (id in room.caps.displays) {
                if (!room.caps.displays.hasOwnProperty(id)) continue;
                rebuildSourceInstructions(id);
            }
        }

        // Depends on vm.configuredDisplays, vm.displays, and vm.uiDisplayState
        // getter/setters being updated
        if (shouldUpdateDisplayControls) {
            var updateDisplayControlsPromise =
                displayControlMenuPromise !== null ? displayControlMenuPromise : $q.resolve();
            updateDisplayControlsPromise.then(function (menu) {
                if (menu && menu.isShown()) menu.hide();
                updateDisplayControls();
            });
        }

        var displaysState = sutl.getNode(room, 'states.displays');
        for (id in displaysState) {
            if (!displaysState.hasOwnProperty(id)) continue;
            for (var prop in vm.uiDisplayState[id]) {
                if (!vm.uiDisplayState[id].hasOwnProperty(prop)) continue;
                var val = sutl.getNode(displaysState, [id, prop]);
                if (val !== null && val !== sutl.getNode(previousDisplaysState, [id, prop])) {
                    var setter = sutl.getNode(vm.uiDisplayState, [id, prop]);
                    if (setter === null) {
                        log.warning('No uiDisplayState setter for ' + id + ', ' + prop);
                    } else {
                        setter(val, true);
                        if (prop === 'videoInput') videoInputWasSelected = true;
                    }
                }
            }
        }

        var displayStatesChanged = false;
        if (
            displaysState !== null &&
            (previousDisplaysState === null ||
                !sutl.objEquals(previousDisplaysState, displaysState))
        ) {
            displayStatesChanged = true;
            previousDisplaysState = sutl.deepCopy(displaysState);
        }

        if (shouldUpdateDisplayControls || displayStatesChanged) {
            $timeout(updateSelectedMediaTab, 250);
        }

        var selectedDisplayId = vm.selectedDisplayId;
        if (
            !angular.isDefined(selectedDisplayId) ||
            sutl.getNode(room, ['configuredCaps', 'displays', selectedDisplayId]) === null
        ) {
            var keys = room.configuredCaps.displays
                ? Object.keys(room.configuredCaps.displays).sort()
                : [];
            selectedDisplayId = keys.length > 0 ? keys[0] : undefined;
        }
        var selectedDisplay = vm.getDisplay(selectedDisplayId);
        var selectedSourceId = getSelectedSourceId(selectedDisplayId);
        var channelFavorites = sutl.getNode(selectedDisplay, [
            'sources',
            selectedSourceId,
            'channelFavorites',
        ]);
        if (
            (previousChannelFavorites === null && channelFavorites !== null) ||
            !sutl.objEquals(channelFavorites, previousChannelFavorites)
        ) {
            previousChannelFavorites = sutl.deepCopy(channelFavorites);
            vm.channelFavorites = channelFavorites
                ? $filter('orderObjectBy')(sutl.deepCopy(channelFavorites), 'index', false, true)
                : null;
        }

        if (displayStatesChanged || selectedDisplayId !== previousSelectedDisplayId) {
            // Create a list of display source states with one item for each
            // state for easier limitTo counting
            var sources = objToArray(
                sutl.deepCopy(
                    sutl.getNode(room, ['states', 'displays', selectedDisplayId, 'sources'])
                )
            );
            var sourceStates = [];
            angular.forEach(sources, function (source) {
                for (var stateName in DisplaySourceStateService.getSourceStateInfo()) {
                    if (
                        !isSourceStateless(
                            getSource(selectedDisplayId, source.$id),
                            DisplaySourceStateService.getSourceStateInfo(stateName)
                                .isStatelessProperty
                        ) &&
                        DisplaySourceStateService.getActiveSourceStatesCount(
                            selectedDisplayId,
                            source.$id,
                            stateName
                        ) > 0
                    ) {
                        sourceStates.push(
                            angular.extend(
                                {
                                    $stateName: stateName,
                                    $state: sutl.deepCopy(
                                        DisplaySourceStateService.getSourceStateInfo(stateName)
                                    ),
                                },
                                source
                            )
                        );
                    }
                }
            });
            vm.selectedDisplaySourceStates = sourceStates;
        }
        if (displayStatesChanged) DisplaySourceStateService.updateElapsedTimeInterval();

        if (selectedDisplayId !== previousSelectedDisplayId || videoInputWasSelected) {
            var selectedSource = getSelectedSource(selectedDisplayId);
            vm.mediaControlsRight.length = 0;
            if (selectedSource !== null) {
                var overflowMediaButtons = getAllMediaControlButtonsWithPriority(
                    selectedSource,
                    hasMediaOperation(selectedSource, 'directionUpDownLeftRight') ? 5 : 1
                );
                var i = 0;
                var j = 0;
                var row;
                while (i < mediaControlsRightTemplate.length || j < overflowMediaButtons.length) {
                    row = 0;
                    while (
                        row < 4 &&
                        (i < mediaControlsRightTemplate.length || j < overflowMediaButtons.length)
                    ) {
                        if (vm.mediaControlsRight.length < 4) vm.mediaControlsRight.push([]);
                        if (i < mediaControlsRightTemplate.length) {
                            if (
                                (mediaControlsRightTemplate[i].capsMediaOperation &&
                                    hasMediaOperation(
                                        selectedSource,
                                        mediaControlsRightTemplate[i].capsMediaOperation
                                    )) ||
                                hasMediaOperation(
                                    selectedSource,
                                    mediaControlsRightTemplate[i].mediaOperation
                                )
                            ) {
                                vm.mediaControlsRight[row].push(mediaControlsRightTemplate[i]);
                                row++;
                            }
                            i++;
                        } else if (j < overflowMediaButtons.length) {
                            if (
                                (overflowMediaButtons[j].capsMediaOperation &&
                                    hasMediaOperation(
                                        selectedSource,
                                        overflowMediaButtons[j].capsMediaOperation
                                    )) ||
                                hasMediaOperation(
                                    selectedSource,
                                    overflowMediaButtons[j].mediaOperation
                                )
                            ) {
                                vm.mediaControlsRight[row].push(overflowMediaButtons[j]);
                                row++;
                            }
                            j++;
                        }
                    }
                }
            }
        }

        if (selectedDisplayId !== previousSelectedDisplayId) {
            previousSelectedDisplayId = selectedDisplayId;
            if (sourceStateMenuPromise !== null) {
                sourceStateMenuPromise.then(function (menu) {
                    if (menu.isShown()) menu.hide();
                });
            }
            $timeout(function () {
                vm.selectedDisplayId = selectedDisplayId;
            });
        }

        function queryVideoInput(id, resetTimeout) {
            // We are debouncing the busy state as well. If the display is busy
            // just return the currently selected videoInput.
            var busyFn = sutl.getNode(vm.uiDisplayState, [id, 'busy']);
            $timeout(updateSelectedMediaTab);
            if (busyFn && busyFn()) {
                resetTimeout();
                return vm.uiDisplayState[id].videoInput();
            }
            return sutl.getNode(room, ['states', 'displays', id, 'videoInput']);
        }

        function queryDisplayBusy(id, resetTimeout) {
            return sutl.getNode(room, ['states', 'displays', id, 'busy'], false);
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
        } else if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
            previousDisplays = null;
            previousConfiguredDisplays = null;
            previousDisplaysState = null;
            previousChannelFavorites = null;
            previousSelectedDisplayId = null;
        }
    }

    function onSelectSource(displayId, source, $event) {
        if (room === null || !RoomService.online()) return;
        var msg = getUnavailableReasonMsg(displayId, source.$key);
        if (msg !== null) {
            vm.tooltip.show(msg, $event);
            return;
        }
        vm.uiDisplayState[displayId].videoInput(source.$key);
        updateSelectedMediaTab();
        var promise = displaySourceMenu !== null ? displaySourceMenu.hide() : $q.resolve();
        promise.then(function () {
            if (room === null || !RoomService.online()) return;
            log.info('selected display ' + displayId + ', source: ' + source.$key);
            room.$requestDisplaySource(displayId, source.$key);
        });
    }

    function onShowChannelSelectionMenu(source, $event) {
        $scope.source = source;
        return createChannelSelectionMenu().then(function (popover) {
            channelSelectionMenu = popover;
            channelSelectionMenu.show($event);
        });
    }

    function onShowDisplayControlMenu(displayId, $event) {
        $scope.displayControlDisplayId = displayId;
        return createDisplayControlMenu().then(function (popover) {
            displayControlMenu = popover;
            displayControlMenu.show($event);
        });
    }

    function onShowDisplaySourceMenu(displayId, $event) {
        $scope.displayId = displayId;
        $scope.display = sutl.deepCopy(vm.getDisplay(displayId));
        var sources = sutl.getNode($scope, 'display.sources');
        var sourcesCount = sources !== null ? Object.keys(sources).length : 0;
        if (sourcesCount === 0) return $q.resolve();
        return createDisplaySourceMenu().then(function (menu) {
            return menu.show($event).then(scrollToSelected);
        });
    }

    function onShowSourceStateMenu($event) {
        return createSourceStateMenu().then(function (popover) {
            sourceStateMenu = popover;
            sourceStateMenu.show($event);
        });
    }

    function onStatelessHelpClicked($event) {
        var msg = [
            /// User help text for display selection when using IR transmitter (part 1/2)
            gettextCatalog.getString(
                'Because this system uses infrared signals to control the ' +
                    'display, the display and selected source could become ' +
                    'unsynchronized.'
            ),
            /// User help text for display selection when using IR transmitter (part 2/2)
            gettextCatalog.getString(
                'Select the source again if you do not see it on the display.'
            ),
        ];
        vm.tooltip.show(msg, $event);
    }

    function onStopSourceState(displayId, sourceId, stateName) {
        var source = sutl.getNode(vm.getDisplay(displayId), ['sources', sourceId]);
        switch (stateName) {
            case 'state':
                room.$requestStopContent(displayId, sourceId);
                break;

            case 'mediaPlayerState':
                onMediaControlButtonClicked(source, 'mediaPlayerStop');
                break;

            case 'mediaRecorderState':
                onMediaControlButtonClicked(source, 'mediaRecorderStop');
                break;

            case 'mediaStreamerState':
                onMediaControlButtonClicked(source, 'mediaStreamerStop');
                break;

            default:
                log.warning('Tried to stop source state of unknown type: ' + stateName);
                break;
        }
        if (sourceStateMenuPromise !== null) {
            sourceStateMenuPromise.then(function (menu) {
                if (menu.isShown()) menu.hide();
            });
        }
    }

    function onTabCountChanged(tabCount) {
        vm.tabCount = tabCount;
    }

    function onTabSelected(tab) {
        $timeout(function () {
            if (tab.tabData !== vm.selectedDisplayId) {
                delete vm.selectedMediaTab;
                vm.selectedDisplayId = tab.tabData;
                onRoomChanged();
                updateSelectedMediaTab();
            }
        });
    }

    function rebuildSourceInstructions(displayId) {
        sourceInstructions[displayId] = {};
        for (var sourceId in room.caps.displays[displayId].sources) {
            if (!room.caps.displays[displayId].sources.hasOwnProperty(sourceId)) continue;
            var source = room.caps.displays[displayId].sources[sourceId];
            if (!angular.isDefined(source.instructions)) continue;

            if (source.instructions.type === 'zoomAirPlay') {
                sourceInstructions[displayId][sourceId] = [
                    {
                        steps: [
                            {
                                /// Zoom sharing instructions (AirPlay)
                                label: gettextCatalog.getString('Choose Wi-Fi'),
                                value: getInstrProp(displayId, sourceId, 'wifiNetwork', ''),
                            },
                            {
                                /// Zoom sharing instructions (AirPlay), part of 'Select AirPlay' (part 1/2)
                                label: gettextCatalog.getString('Select'),
                                /// Zoom sharing instructions (AirPlay), part of 'Select AirPlay' (part 2/2)
                                value: gettextCatalog.getString('AirPlay'),
                            },
                            {
                                /// Zoom sharing instructions (AirPlay), part of 'Choose {{roomName}}' (part 1/2)
                                label: gettextCatalog.getString('Choose'),
                                value: getInstrProp(displayId, sourceId, 'roomName', ''),
                                /// Zoom sharing instructions (AirPlay), follows 'Choose {{roomName}}' (part 2/2)
                                note: gettextCatalog.getString("Can't see it? Restart iPhone/iPad"),
                            },
                            {
                                /// Zoom sharing instructions (AirPlay), part of 'Enable Mirroring' (part 1/2)
                                label: gettextCatalog.getString('Enable'),
                                /// Zoom sharing instructions (AirPlay), part of 'Enable Mirroring' (part 2/2)
                                value: gettextCatalog.getString('Mirroring'),
                            },
                            {
                                /// Zoom sharing instructions (AirPlay), part of 'Password {{password}}'
                                label: gettextCatalog.getString('Password'),
                                value: getInstrProp(displayId, sourceId, 'password', ''),
                            },
                        ],
                    },
                ];
            } else if (source.instructions.type === 'zoomDesktop') {
                sourceInstructions[displayId][sourceId] = [
                    {
                        /// Zoom sharing instructions
                        title: gettextCatalog.getString('Use Zoom Desktop App'),
                        steps: [
                            {
                                /// Zoom sharing instructions (Zoom Desktop), part of 'Click Share Screen' (part 1/2)
                                label: gettextCatalog.getString('Click'),
                                /// Zoom sharing instructions (Zoom Desktop), part of 'Click Share Screen' (part 2/2)
                                value: gettextCatalog.getString('Share Screen'),
                            },
                            {
                                /// Zoom sharing instructions (Zoom Desktop), part of 'Sharing Key {{sharingKey}}'
                                label: gettextCatalog.getString('Sharing Key'),
                                value: getInstrProp(displayId, sourceId, 'sharingKey', ''),
                            },
                        ],
                    },
                    {
                        /// Zoom sharing instructions
                        title: gettextCatalog.getString('Use Browser'),
                        steps: [
                            {
                                /// Zoom sharing instructions (Browser), part of 'Go to share.zoom.us'
                                label: gettextCatalog.getString('Go to'),
                                value: 'share.zoom.us',
                            },
                            {
                                /// Zoom sharing instructions (Browser), part of 'Meeting ID {{meetingId}}'
                                label: gettextCatalog.getString('Meeting ID'),
                                value: formatMeetingId(
                                    getInstrProp(displayId, sourceId, 'meetingNumber', '')
                                ),
                                showValueSpinner: function (value) {
                                    return value === 'not in a meeting';
                                },
                            },
                            {
                                /// Zoom sharing instructions (Browser), part of 'Password {{password}}'
                                label: gettextCatalog.getString('Password'),
                                value: getInstrProp(displayId, sourceId, 'meetingPassword', ''),
                                showValue: function (value) {
                                    return (
                                        typeof value !== 'undefined' &&
                                        value !== null &&
                                        value.length > 0 &&
                                        value !== 'not in a meeting'
                                    );
                                },
                            },
                        ],
                    },
                ];
            }
        }

        function getInstrProp(displayId, sourceId, property, defaultValue) {
            var path = ['caps', 'displays', displayId, 'sources', sourceId, 'instructions'];
            if (property !== null) {
                path.push(property);
            }
            return sutl.getNode(room, path, defaultValue);
        }
    }

    function scrollToSelected() {
        if (displaySourceMenu === null || !angular.isDefined($scope.displayId)) {
            return;
        }
        var sourceId = vm.uiDisplayState[$scope.displayId].videoInput();
        var item = displaySourceMenu.modalEl.querySelector('#' + sourceId);
        if (!item) return;
        if (item.offsetTop < displaySourceMenu.modalEl.scrollTop) {
            $ionicScrollDelegate
                .$getByHandle('display-source-scroll')
                .scrollTo(0, item.offsetTop, true);
        } else if (item.offsetTop + item.offsetHeight > displaySourceMenu.modalEl.clientHeight) {
            $ionicScrollDelegate
                .$getByHandle('display-source-scroll')
                .scrollTo(
                    0,
                    item.offsetTop + item.offsetHeight - displaySourceMenu.modalEl.clientHeight,
                    true
                );
        }
    }

    function showMediaControls(displayId) {
        var sourceId = getSelectedSourceId(displayId);
        return (
            getMediaOperations(displayId, sourceId) !== null ||
            getSourceInstructions(displayId, sourceId) !== null
        );
    }

    function updateDisplayControls() {
        for (var displayId in vm.configuredDisplays) {
            if (!vm.configuredDisplays.hasOwnProperty(displayId)) continue;
            if (!angular.isDefined(displayControls[displayId])) displayControls[displayId] = [];
            // rebuild display controls
            displayControls[displayId].length = 0;
            createDisplayControls(displayId);
        }
        for (displayId in displayControls) {
            if (!displayControls.hasOwnProperty(displayId)) continue;
            if (sutl.getNode(vm.configuredDisplays, displayId) === null) {
                delete displayControls[displayId];
            }
        }

        function createDisplayControls(displayId) {
            var controlIndex = 0;
            var control;
            if (vm.configuredDisplays[displayId].hasPowerControl) {
                control = createOnOffControl(
                    displayId,
                    getPowerButtonLabel,
                    'power',
                    'ion-aveo-power-off',
                    'ion-record',
                    'isPowerStateless',
                    'ion-aveo-power',
                    'isPowerToggle'
                );
                displayControls[displayId].splice(controlIndex, 0, control);
            }
            if (getDisplay(displayId).hasBlank && getDisplay(displayId).hasBlankUi) {
                control = createOnOffControl(
                    displayId,
                    getBlankButtonLabel,
                    'blank',
                    'ion-android-close',
                    'ion-aveo-checkmark',
                    'isBlankStateless'
                );
                controlIndex = sutl.getNode(
                    getDisplay(displayId),
                    'blankIndex',
                    displayControls[displayId].length
                );
                displayControls[displayId].splice(
                    controlIndex + (vm.configuredDisplays[displayId].hasPowerControl ? 1 : 0),
                    0,
                    control
                );
            }
            if (getDisplay(displayId).hasFreeze && getDisplay(displayId).hasFreezeUi) {
                control = createOnOffControl(
                    displayId,
                    getFreezeButtonLabel,
                    'freeze',
                    'ion-android-close',
                    'ion-aveo-checkmark',
                    'isFreezeStateless'
                );
                controlIndex = sutl.getNode(
                    getDisplay(displayId),
                    'freezeIndex',
                    displayControls[displayId].length
                );
                displayControls[displayId].splice(
                    controlIndex + (vm.configuredDisplays[displayId].hasPowerControl ? 1 : 0),
                    0,
                    control
                );
            }
            var displayMotion = sutl.getNode(getDisplay(displayId), 'displayMotion');
            if (displayMotion !== null) {
                for (var displayMotionId in displayMotion) {
                    if (!displayMotion.hasOwnProperty(displayMotionId)) continue;
                    if (
                        !sutl.getNode(displayMotion, [displayMotionId, 'showManualControls'], false)
                    ) {
                        continue;
                    }
                    control = createDisplayMotionControl(displayId, displayMotion, displayMotionId);
                    controlIndex = sutl.getNode(
                        displayMotion,
                        [displayMotionId, 'index'],
                        displayControls[displayId].length
                    );
                    displayControls[displayId].splice(
                        controlIndex + (vm.configuredDisplays[displayId].hasPowerControl ? 1 : 0),
                        0,
                        control
                    );
                }
            }

            function createOnOffControl(
                displayId,
                getLabel,
                getterSetterName,
                offIconClass,
                onIconClass,
                isStatelessName,
                toggleIconClass,
                isToggleName
            ) {
                return {
                    type: 'onOff',
                    getLabel: getLabel,
                    getterSetter: sutl.getNode(vm.uiDisplayState, [displayId, getterSetterName]),
                    offIconClass: offIconClass,
                    onIconClass: onIconClass,
                    toggleIconClass: toggleIconClass,
                    isDisabled: function () {
                        return !getDisplay(displayId);
                    },
                    isStateless: function () {
                        return angular.isDefined(isStatelessName)
                            ? sutl.getNode(getDisplay(displayId), isStatelessName, false)
                            : false;
                    },
                    isToggle: function () {
                        return angular.isDefined(isToggleName)
                            ? sutl.getNode(getDisplay(displayId), isToggleName, false)
                            : false;
                    },
                };
            }

            function createDisplayMotionControl(displayId, displayMotion, displayMotionId) {
                // We use the same function for the onTouch and onRelease handlers, just
                // parameterized differently in the template
                var wrappedHandlers = IosTouchEventService.wrapHandlers(onControl, onControl);
                return {
                    type: 'displayMotion',
                    getLabel: function () {
                        return sutl.getNode(displayMotion, [displayMotionId, 'label'], '');
                    },
                    controls: sutl.getNode(displayMotion, [displayMotionId, 'controls']),
                    getIcon: function (controlKey) {
                        var iconName = sutl.getNode(
                            displayMotion,
                            [displayMotionId, 'controls', controlKey, 'icon'],
                            ''
                        );
                        if (iconName.length === 0) return iconName;
                        return 'ion-aveo-' + iconName.replaceAll('_', '-');
                    },
                    isDisabled: function () {
                        return (
                            sutl.getNode(vm.displays, [
                                displayId,
                                'displayMotion',
                                displayMotionId,
                            ]) === null
                        );
                    },
                    onControlRelease: wrappedHandlers.onRelease,
                    onControlTouch: wrappedHandlers.onTouch,
                };

                function onControl($event, controlKey, manual) {
                    if (controlKey !== 'hide' && controlKey !== 'show' && controlKey !== 'stop') {
                        log.warning('Invalid display motion control key: ' + controlKey);
                        return;
                    }
                    // build function name like: $requestHideDisplay
                    var fnName =
                        '$request' + controlKey[0].toUpperCase() + controlKey.substr(1) + 'Display';
                    log.info(
                        'onControl: ' +
                            fnName +
                            '(' +
                            displayId +
                            ', ' +
                            displayMotionId +
                            ', ' +
                            manual +
                            ')'
                    );
                    room[fnName](displayId, displayMotionId, manual);
                }
            }
        }
    }

    function updateSelectedMediaTab() {
        var availableMediaTabs = vm.mediaTabs.filter(vm.isMediaTabSupported);
        if (availableMediaTabs.length === 0) {
            delete vm.selectedMediaTab;
            return;
        }
        var found = availableMediaTabs.find(function (el) {
            return el.name === vm.selectedMediaTab;
        });
        $timeout(function () {
            var tabs = aveoTabsDelegate.$getByHandle('media-control-tabs');
            if (tabs) {
                tabs.selectTabWithData(
                    found && vm.selectedMediaTab ? vm.selectedMediaTab : availableMediaTabs[0].name
                );
            }
        }, 250);
    }
}

module.exports = DisplayController;
